//verify otp
export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_RECEIVE = "VERIFY_OTP_RECEIVE";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";
export const RESET_VERIFY_OTP= "RESET_VERIFY_OTP";